import { useTranslation } from "react-i18next";

import { UpdatePPH } from "src/brand/EC/components/folder/UpdatePPH";
import { FolderEntreprise } from "src/core/components/folder/FolderEntreprise";
import { UpdateStakeholderFullForm } from "src/core/components/folder/stakeholders/UpdateStakeholderFullForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { MappedStakeholder } from "src/core/constants/folder";
import { cn } from "src/core/lib/utils";

type UpdateStakeholderModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  stakeholder: MappedStakeholder;
  isPPH?: boolean;
};

export const UpdateStakeholderModal = ({
  open,
  setOpen,
  stakeholder,
  isPPH = false,
}: UpdateStakeholderModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className={cn("!px-10", { "!w-[800px]": !isPPH, "!w-[880px]": isPPH })}
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="flex flex-col max-h-[80vh]">
          <div className="flex-1 overflow-y-auto px-5">
            <DialogHeader>
              <DialogTitle className={isPPH ? "uppercase" : ""}>
                {isPPH
                  ? t("folder.stakeholders.sectionTitlePPH")
                  : stakeholder.isFolderCustomer
                  ? stakeholder.socialReason
                  : stakeholder.firstName?.split(",")[0] +
                    " " +
                    stakeholder.lastName?.toUpperCase()}
              </DialogTitle>
              <DialogDescription className="sr-only">
                {stakeholder.socialReason ?? stakeholder.firstName}
              </DialogDescription>
            </DialogHeader>

            {stakeholder.isFolderCustomer ? (
              isPPH ? (
                <UpdatePPH setOpen={setOpen} onSuccess={() => setOpen(false)} />
              ) : (
                <FolderEntreprise inModal setOpen={setOpen} onSuccess={() => setOpen(false)} />
              )
            ) : (
              <UpdateStakeholderFullForm
                selectedStakeholderForEdit={stakeholder}
                inModal
                setOpen={setOpen}
                onSuccess={() => setOpen(false)}
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
